<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <!-- 导航 -->
            <matrixMenu></matrixMenu>
        </div>
        <div class="bgfff mt20">
            <div class="bd bd-b clearfix">
                <div class="filter-tabs">
                    <a href="javascript:void(0);" :class="{active:materialType === 1}" @click="typeTab(1);">微信文章</a>
                    <!-- <a href="javascript:void(0);" class="ml30" :class="{active:materialType === 2}" @click="typeTab(2);">头条文章</a> -->
                </div>
            </div>
            <div class="">
                <div class="clearfix listloop-wrap profile" v-for="(item,index) in materialList" :key="index">
                    <div class="fl profile-img" v-if="materialType===1">
                        <img :src="item.cover" width="180" height="100" />
                    </div>
                    <div class="fr profile-btn mt40">
                        <router-link :to="{path:'/onlineEdit',query:{formType:3,id:item.id,type:materialType}}" class="edit color-blue"><i class="icons icon-edit"></i>编辑</router-link>
                        <a href="javascript:void(0);" class="collec color-yellow ml10" :class="{active:item.status === 1}" @click="collectNews(index);"><i class="icons icon-collec"></i>收藏</a>
                    </div>
                    <div class="profile-info hidden" :class="materialType===2?'pl0':''">
                        <a :href="item.link" target="_blank"><h3 class="profile-tit">{{item.title}}</h3></a>
                        <p class="profile-art color-gray">{{item.summary}}</p>
                        <div class="profile-status mt30">
                            <span class="color_gray name"><i class="icons name-icon"></i>{{item.author}}</span>
                            <span class="ml10 color_gray time"><i class="icons time-icon"></i>发布时间：{{item.posttime}}</span>
                            <span class="ml10 color_gray read" v-if="materialType===2">阅读数：{{item.hits}}</span>
                            <span class="ml10 color_gray praise" v-if="materialType===2">评论数：{{item.likes}}</span>
                        </div>
                    </div>
                </div>
                <!-- 暂无数据 -->
                <div class="no-data" v-if="materialList <= 0 && !$parent.showLoad"><img src="/static/images/no_data.png" class="img" /><span class="text">没有数据哦...</span></div>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
       </div>
  	</div>
</template>
<script>
import page from '../../components/page.vue';
import matrixMenu from './matrixMenu.vue';
export default {
    components:{page,matrixMenu},
    data() {
        return {
           materialList:[],//素材列表
           materialType:1,
           totalCount:'',//总条数
           page:1,//当前页码
           limit:10//一页显示条数
        }
    },
    mounted() {
		let that = this;
        this.$nextTick(()=> {
            that.getMaterialList(1);
        })
    },
    created() {
		
    },
    methods: {
        // 微信头条切换
        typeTab (type) {
            let that = this;
            that.materialType = type;
            that.getMaterialList(type);
        },
        //获取素材
        getMaterialList (type) {
            let that = this;
            let url = '';
            if(type === 1){//微信头条类型
                url = 'matrix/wxlist'
            }else if(type === 2){
                url = 'matrix/ttlist'
            }
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post(url,{page:that.page,pagesize:that.limit},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.materialList = r.data.data;
                    that.limit = r.data.count;
                    that.totalCount = r.data.total;
                })
            })
        },
        // 翻页
        getTableData () {
            let that = this;
            let type = that.materialType;
            that.getMaterialList(type);
        },
        // 收藏
        collectNews (index) {
            let that = this;
            let list = that.materialList;
            let status = list[index].status;
            let id = list[index].id;
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('material/collect',{source:that.materialType,type:2,sn:id},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    if(status === 1){
                        list[index].status = 0;
                    }else{
                        list[index].status = 1;
                    }
                })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/materialCenter/rectifyArticle.vue